import React, {useMemo} from 'react';
import classnames from 'classnames'
import './index.less';
import { getCurrentPrice } from '../../pages/pile-sharing/utils';

export interface Price  {
    startTime: string
    endTime: string
    servicePrice: number
}
const PREFIX = 'charge-web-cpn-price-list'
const defaultTips = '展示价格为该订单实际单价'


const mergePrices = (periods: Price[]): Price[] => {
    if (periods.length === 0) return [];

    const mergedPeriods: Price[] = [];
    let currentPeriod = { ...periods[0]};

    for (let i = 1; i < periods.length; i++) {
        const nextPeriod = periods[i];

        if (currentPeriod.servicePrice === nextPeriod.servicePrice && currentPeriod.endTime === nextPeriod.startTime) {
            currentPeriod.endTime = nextPeriod.endTime;
        } else {
            mergedPeriods.push(currentPeriod);
            currentPeriod = {...nextPeriod};
        }
    }

    mergedPeriods.push(currentPeriod);
    return mergedPeriods;
};



export default function PriceList({ merge, isPureList = false, tips, priceList, lowestPrice }: {merge?:boolean, isPureList?: boolean, tips?: string, currentItem?: any, lowestPrice?: number, priceList: Price[]}) {
    const list = useMemo(()=> merge ? mergePrices(priceList): priceList, [priceList, merge])
    const currentItem =  list && getCurrentPrice(list)
    return <div className={`${PREFIX}`} >
        {
            list.map((item) => {
                const isCurrent = currentItem && currentItem === item
                const isLowestPrice = lowestPrice && item.servicePrice === lowestPrice;
                const itemClassName = classnames(`${PREFIX}-item`, {
                    [`${PREFIX}-item-actived`]: !isPureList && isCurrent
                })
                return <div className={itemClassName} key={item.startTime}>
                        {
                            !isPureList 
                                &&
                            <div className={`${PREFIX}-item-positionWrap`}>
                                {
                                     lowestPrice && isLowestPrice  && list.length > 1
                                     &&  <div className={`${PREFIX}-item-lowestPriceWrap`}>
                                            <span className={`${PREFIX}-item-lowestPrice`} >价格最低</span>
                                        </div>
                                }
                               
                                {
                                    currentItem && isCurrent 
                                    &&  <div className={`${PREFIX}-item-currentTimeWrap`} >
                                            <span className={`${PREFIX}-item-currentTime`}>当前时段</span>
                                        </div>
                                }
                            </div>    
                        }
                            
                                 
                            <div  className={`${PREFIX}-item-PriceItemTime`}>{`${item.startTime}~${item.endTime}`}</div>
                            <div className={`${PREFIX}-item-PriceItemPrice`}>¥{item.servicePrice}<span  className={`${PREFIX}-item-PriceItemUnit`}>/度</span></div>
                        </div>
            })
        }
        <div  className={`${PREFIX}-tips`}>{tips || defaultTips}</div>
    </div>
}